import React from "react";

import SelectionFilter from "@src/features/table_filtering/components/selection_filter/selection_filter";
import {
  RESOURCE_PLAN_FILTER_TYPES,
  setSentRequestsCustomTableFilter,
} from "@src/services/resourcePlanSlice";
import { useAppDispatch, useAppSelector } from "@src/setupStore";
import { TreeNode } from "@src/types/antd_types";

interface FilterSentRequestsProps {
  disabled: boolean;
  roles: TreeNode[];
}

export const FilterSentRequests: React.FC<FilterSentRequestsProps> = ({
  disabled,
  roles,
}) => {
  const dispatch = useAppDispatch();
  const {
    sentRequestsTableState: { customTableFilters },
  } = useAppSelector((state) => state.resourcePlanSlice);

  /**
   * updates the state of the custom table filter by the given type.
   *
   * @param {string[]} values - The values of the filter.
   * @param {RESOURCE_PLAN_FILTER_TYPES} type - The type of the filter.
   */
  function updateCustomTableFilterByType(
    values: string[],
    type: RESOURCE_PLAN_FILTER_TYPES
  ) {
    dispatch(
      setSentRequestsCustomTableFilter({
        ...customTableFilters,
        [type]: values,
      })
    );
  }

  return (
    <SelectionFilter
      title="Role"
      treeData={roles}
      disabled={disabled}
      defaultKeys={customTableFilters.genericRoleName}
      onFilter={(values: string[]) => {
        updateCustomTableFilterByType(values, RESOURCE_PLAN_FILTER_TYPES.ROLES);
      }}
    />
  );
};
